import { Form } from 'react-bootstrap';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useSearchParams } from 'react-router-dom';
import { ICategoryTreeItem } from '../../content-tree/types';
import {
  articleIdUrlParam,
  categoryIdUrlParam,
} from '../../../shared/constants';
import {
  useGetApiArticlesReferencesQuery,
  useGetApiCategoriesArticleReferencesByIdQuery,
} from '../../../redux/store/api/api';
import { useAppSelector } from '../../../redux/hooks';
import { selectActiveVersion } from '../../../redux/store/content/slice';

interface IReferenceCategoryTreeItemProps {
  categoryElement: ICategoryTreeItem;
  selectable: boolean;
  isSelected: boolean;
  handleSelect: Function;
  allowMultipleReferenceOnSameTarget?: boolean;
  allowDisabling?: boolean;
}

function ReferenceCategoryTreeItem({
  categoryElement,
  selectable,
  isSelected,
  handleSelect,
  allowMultipleReferenceOnSameTarget,
  allowDisabling,
}: IReferenceCategoryTreeItemProps) {
  const [searchParams] = useSearchParams();
  const categoryId: string | null = searchParams.get(categoryIdUrlParam);
  const articleId: string | null = searchParams.get(articleIdUrlParam);
  const activeVersion = useAppSelector(selectActiveVersion);
  const { data: referencesOfCategory } =
    useGetApiCategoriesArticleReferencesByIdQuery(
      categoryId ? { id: categoryId } : skipToken,
    );
  const { data: referencesOfArticle } = useGetApiArticlesReferencesQuery(
    articleId && activeVersion.id
      ? {
          articleId,
          versionId: activeVersion.id,
        }
      : skipToken,
  );

  return (
    <>
      {selectable && (
        <Form.Check
          tabIndex={-1}
          id={categoryElement.id}
          onClick={(e) => {
            handleSelect(e);
            e.stopPropagation();
          }}
          onChange={(e) => {
            e.stopPropagation();
          }}
          checked={isSelected}
          disabled={
            allowDisabling
              ? !allowMultipleReferenceOnSameTarget &&
                (!!referencesOfArticle?.resultObject?.articleReferenceLists?.find(
                  (r) =>
                    !!r.articleReferences?.find(
                      (a) =>
                        a.targetCategoryId === categoryElement.id &&
                        a.sourceVersionId === null,
                    ),
                ) ||
                  !!referencesOfCategory?.resultObject?.find(
                    (r) =>
                      !!r.articleReferences?.find(
                        (a) =>
                          a.targetCategoryId === categoryElement.id &&
                          a.sourceVersionId === null,
                      ),
                  ))
              : false
          }
          type='checkbox'
          label={
            <span className='visually-hidden'>{categoryElement.name}</span>
          }
        />
      )}
      <span>
        <i
          aria-hidden
          className={`me-1 ${categoryElement.categoryTypeIconClass}`}
          style={{
            color: categoryElement.categoryTypeColorHexCode,
          }}
        />
        {categoryElement.name}
      </span>
    </>
  );
}

ReferenceCategoryTreeItem.defaultProps = {
  allowMultipleReferenceOnSameTarget: false,
  allowDisabling: true,
};

export default ReferenceCategoryTreeItem;
